<template>

    <!-- 多选上传图片 -->

    <div class="m-img-uploads" >

        <el-tooltip v-for="(it,index) in imgs" :key="index" :placement="placement" effect="light">
            <div slot="content">
                <img :src="it.url" :style="{'width':width*3+'px', 'height':height*3+'px'}">
            </div>
            <div class="img-wrapper" :style="{'width':width+'px', 'height':height+'px'}">
                <img :src="it.url" alt="logo" :style="{'width':width+'px', 'height':height+'px'}">
                <div class="img-edit" :style="{'width':width+'px', 'height':height+'px'}">
                    <i class="el-icon-delete" @click="handleRemove(it.pic_id, index)"></i>
                </div>
            </div>
        </el-tooltip>

        
      <label v-show="max == 0 || imgs.length < max" :style="{'width':width+'px', 'height':height+'px',}"  class="input-label" v-loading="loading">
        <i class="el-icon-plus upload-icon"></i>
        <input @change="handleChange($event)" type="file" accept=".jpg,jpeg,.png" multiple="multiple" style="display:none">
      </label>

    </div>
</template>

<script>
import { uploads, imgDelete } from '@/untils/axios.js'

export default {
  name:"Upload",
  props:{
    fileName:{
      type:String,
      default:'',
      required:true,
    },
    width:{
      type:Number,
      default:80
    },
    height:{
      type:Number,
      default:80
    },
    placement: {
      type: String,
      default: 'top',
    },
    imgs: {
      type: Array,
      default: () => [],
      required: true
    },
    max:{
      type:Number,
      default: 0,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  methods:{
    handleChange(e){
      let files = Array.from(e.target.files);
      console.log( e.target.files);
      var image = new FormData()
      if(this.imgs.length + files.length > this.max && this.max != 0) {
        this.$message.error(`所传图片不能超过${this.max}张`)
        return false
      }

      image.append('filename', this.fileName)

      files.forEach( (e,index) => {
        image.append(`file[${index}]`, e)
      })

      this.loading = true
      uploads(image).then(res => {
        if(res){
          this.imgs    = [...this.imgs, ...res.data.reverse()]
          // this.imgs.reverse()
          this.$emit('update:imgs', this.imgs)
        }
      }).finally( () => {
        this.loading = false
      })

    },

    handleRemove(id, index) {
      if(id != "") {
        imgDelete(id).then( res => {
          if(res) {
            this.imgs.splice(index, 1)
            this.$emit('update:imgs', this.imgs)
          }
        })
      }
    }

  },
}
</script>

<style lang="less" scoped>
.m-img-uploads{
  width: 100%;
  display: flex;
  flex-wrap: wrap;
    .img-wrapper {
      display: inline-block;
      position: relative;
      border-radius: 4px;
      margin-right:10px;
      &:hover {
          .img-edit {
              opacity: 1;
          }
      }
      img{ 
          object-fit: cover;
          border-radius: 4px;
          cursor: pointer;
      }
      .img-edit {
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: rgba(0,0,0,0.5);
          border-radius: 4px;
          opacity: 0;
          transition: opacity .3s;
          >i {
              font-size: 20px;
              color: #fff;
          }
      }
    }
  .input-label {
    display: inline-block;
    border: 1px dashed #d9d9d9;
    border-radius: 5px;
    text-align: center;
  }
  .input-label:hover{
    border-color:#409EFF ;
  }
  .upload-icon {
    font-size: 24px;
    color: #8c939d;
    position: relative;
    top: 50%; /*偏移*/
    transform: translateY(-50%);
  }
}
  
</style>